import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { TablerCaretUpDownFilled } from "../../assets/icons/LayoutIcon";
import useSortableData from "../../utils/SortData";
import EmptyTable from "../Layout/EmptyTable";

const ViewTable = ({ data = [], headers = [], renderCell = () => null }) => {
  const { sortedItems, handleSort } = useSortableData(data);

  return (
    <div className="rounded-lg  sm:border border-gray-300 overflow-x-auto my-4">
      <Table className="w-full border-gray-300 rounded-lg">
        <Thead className="bg-gray-100 sm:border-b rounded-lg">
          <Tr>
            {headers.map((header, index) => (
              <Th
                key={index}
                className="px-3 py-3 text-left font-semibold text-xs text-text1 cursor-pointer "
                onClick={() =>
                  header.value !== "action" && handleSort(header.value)
                }
              >
                {header.value !== "action" ? (
                  <div className="flex items-center gap-1">
                    <TablerCaretUpDownFilled className="transition-transform hidden sm:block" />
                    <span className="text-text1 text-xs font-semibold">
                      {header.label}
                    </span>
                  </div>
                ) : (
                  <span className="text-text1 text-xs font-semibold">
                    {header.label}
                  </span>
                )}
              </Th>
            ))}
          </Tr>
        </Thead>

        <Tbody>
          {sortedItems.length > 0 ? (
            sortedItems.map((item, index) => (
              <Tr
                key={index}
                className="border-t rounded-lg "
              >
                {headers.map(({ value }) => (
                  <Td
                    key={value}
                    className="px-3 py-4 text-xs font-normal text-text2 "
                  >
                    {renderCell(item, value) || item[value] || "N/A"}
                  </Td>
                ))}
              </Tr>
            ))
          ) : (
            <Tr>
              <Td
                colSpan={headers.length}
                className="px-3 py-4 text-xs font-normal text-text2 border border-gray-400 sm:border-none text-center"
              >
                <EmptyTable />
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </div>
  );
};

export default ViewTable;
